var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * hbox
 */
import Line from '../../shapes/Line';
import VNode from '../vnode';
import * as lodash from '../../utils/lodash';
var HorizontalLine = /** @class */ (function (_super) {
    __extends(HorizontalLine, _super);
    function HorizontalLine(props) {
        var _this = _super.call(this, props) || this;
        _this.type = 'hr';
        _this.defaultProps = {
            width: '100%',
            height: 0,
            borderWidth: 1,
            borderColor: '#333333',
        };
        _this.props = __assign(__assign({}, _this.defaultProps), props);
        return _this;
    }
    HorizontalLine.prototype.render = function () {
        var _a = this.bbox, x = _a.x, y = _a.y, width = _a.width;
        var y0 = y + this.props.borderWidth / 2;
        return new Line(__assign({ x1: x, y1: y0, x2: x + width, y2: y0 }, this.getStyle()));
    };
    HorizontalLine.prototype.computeSize = function () {
        var width = lodash.isNumber(this.props.width) ? this.props.width : 0;
        this.minSize = [this.getClampSize(width, 'width'), this.props.borderWidth];
    };
    HorizontalLine.selfClosing = true;
    return HorizontalLine;
}(VNode));
export default HorizontalLine;
